import * as documentations from 'serviceWorker/db/documentations/documentations';
import * as dbIssues from 'serviceWorker/db/issues/issues';
import * as dbSites from 'serviceWorker/db/sites/sites';
import * as dbLevels from 'serviceWorker/db/levels/levels';
import { documentationEntityToModel } from 'serviceWorker/repository/documentation/mappings';
import { DocumentationModel } from 'shared/domain/documentation/documentationModel';
import { getUsersSynchronized } from '../users/getUsers';
import { createDocumentationSitesAndLevelsMap } from 'serviceWorker/repository/documentation/createDocumentationSitesAndLevelsMap';
import { createDocumentationIssuesMap } from 'serviceWorker/repository/documentation/createDocumentationIssuesMap';
import { createIssueNumberMap } from 'serviceWorker/repository/documentation/createIssueNumberMap';

export async function getDocumentation(
  id: number
): Promise<DocumentationModel> {
  const normalizedId = Number(id);
  const [documentation, users, issues, sites, levels] = await Promise.all([
    documentations.getOne(normalizedId),
    getUsersSynchronized(),
    dbIssues.getAll(),
    dbSites.get(),
    dbLevels.get(),
  ]);
  if (!documentation) {
    throw new Error('Cannot find documentation with id ' + normalizedId);
  }
  const docIssuesMap = createDocumentationIssuesMap(issues, levels);
  const issueNumbers = createIssueNumberMap(issues);
  const { docSitesMap, docLevelsMap } =
    createDocumentationSitesAndLevelsMap(sites, levels);

  return documentationEntityToModel(
    documentation,
    users,
    docIssuesMap,
    issueNumbers,
    docSitesMap,
    docLevelsMap
  );
}
